import { render, staticRenderFns } from "./minformation.vue?vue&type=template&id=3763cee6&scoped=true&"
import script from "./minformation.vue?vue&type=script&lang=js&"
export * from "./minformation.vue?vue&type=script&lang=js&"
import style0 from "./minformation.vue?vue&type=style&index=0&id=3763cee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763cee6",
  null
  
)

export default component.exports